import ReportPayrollNss from '@/api/hr/report-payroll-nss'
import OrgChartStructure from '@/api/hr/org-chart-structure'

export const state = {
  orgChartStructures: [],
  records: [],
  columns: {}
}

export const getters = {}

export const mutations = {
  RECEIVE_RESOURCES(state, { records, columns }) {
    state.records = records
    state.columns = columns
  },

  RECEIVE_ORG_CHART_STRUCTURES(state, orgChartStructures) {
    state.orgChartStructures = orgChartStructures
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign({}, attributes)

    return ReportPayrollNss.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchOrgStructures(context) {
    return OrgChartStructure.get({
      params: {
        page: -1,
        fields: {
          hris_org_chart_structure: 'org_chart_structure_id,org_chart_structure'
        }
      }
    }).then(response => {
      context.commit('RECEIVE_ORG_CHART_STRUCTURES', response.data)
      return Promise.resolve(response)
    })
  },

  exportExcel(context, attributes) {
    return ReportPayrollNss.exportExcel(attributes)
  }
}
